export const createStateCache = ({ wixCodeApi }) => {
    const STATE_KEY = 'WC_STATE_CACHE';
    return {
        setState: (state) => {
            let stringifiedState;
            try {
                stringifiedState = JSON.stringify(state);
            }
            catch (e) { }
            wixCodeApi.window.warmupData.set(STATE_KEY, stringifiedState);
        },
        getState: () => {
            let state;
            try {
                state = JSON.parse(wixCodeApi.window.warmupData.get(STATE_KEY));
            }
            catch (e) { }
            return state;
        },
    };
};
//# sourceMappingURL=create-state-cache.js.map